import { styled } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';

export const Container = styled(Grid)({
    // minHeight: '100vh',
    paddingBottom: 10 
})